import { Button } from "@/frontend/components/ui/button";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from "@/frontend/components/ui/dialog";
import { confirmActionCopy } from "@/frontend/utils/delete-patient-data";
import type { ConfirmActionDialogProps } from "@/frontend/types/delete-patient-data";

/**
 * The single confirmation step every revoke and delete on `/delete-your-data`
 * passes through. Open when `action` is non-null.
 */
export function ConfirmActionDialog({
  action,
  pending,
  graceDays,
  onConfirm,
  onCancel,
}: ConfirmActionDialogProps) {
  const copy = action ? confirmActionCopy(action, graceDays) : null;

  return (
    <Dialog open={!!action} onOpenChange={(open) => { if (!open && !pending) onCancel(); }}>
      <DialogContent
        className="sm:max-w-md"
        showCloseButton={!pending}
        onEscapeKeyDown={(event) => { if (pending) event.preventDefault(); }}
        onPointerDownOutside={(event) => { if (pending) event.preventDefault(); }}
      >
        <DialogHeader>
          <DialogTitle className="text-base">{copy?.title ?? ""}</DialogTitle>
          <DialogDescription className="text-body">{copy?.body ?? ""}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="gap-2 sm:gap-2">
          <Button
            type="button"
            variant="outline"
            className="h-11 w-full sm:h-9 sm:w-auto"
            onClick={onCancel}
            disabled={pending}
          >
            Cancel
          </Button>
          <Button
            type="button"
            variant={action?.kind === "delete" ? "destructive" : "default"}
            className="h-11 w-full sm:h-9 sm:w-auto"
            onClick={onConfirm}
            disabled={pending}
          >
            {pending ? "Working…" : copy?.confirm ?? ""}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
